<template>
  <section>
    <div class="static-page">
      <div class="columns is-centered is-fullheight">
        <div class="static-page-title-container">
          <h1>
            {{ page.title }}
          </h1>
        </div>
      </div>
      <div class="container" v-html="page.html" />
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Hiplok',
  layout: 'static-page',
  computed: {
    ...mapGetters({ page: 'blog/page' }),
  },
}
</script>
